import { render, staticRenderFns } from "./SelectedProduct.vue?vue&type=template&id=78d5678e&scoped=true&"
import script from "./SelectedProduct.vue?vue&type=script&lang=js&"
export * from "./SelectedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProduct.vue?vue&type=style&index=0&id=78d5678e&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5678e",
  null
  
)

export default component.exports